<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/76/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/76/title-1.png" alt="" />
                    <div class="content" style="font-weight: bold">
                        新到都江堰市创新创业的国内外顶尖人才、国家级科技领军人才、地方级科技领军人才。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/76/title-2.png" alt="" />
                    <div class="content">
                        <div class="title" style="
                                    font-size: 0.26rem;
                                    margin-top: 0.13rem;
                                    font-weight: normal;
                                ">
                            <span class="hollow-cricle"></span>稳定工作(缴纳社保)满1年 (2022年4月2日起算)。
                        </div>
                        <div class="des">
                            ( 一
                            )创新人才：一般不超过55周岁，每年在本地知名企业、研发机构或驻市高校工作时间不少于9个月，具有较强的产品开发能力和产业化潜力或能够解决关键技术和工艺操作性难题以及自主创新产品具有国际水平的高层次人才。
                        </div>
                        <div class="des">(二)创业人才：一般不超过55周岁，每年在本地工作时间不少于6个月，作为主要创办人(自然人直接持股，股权不低于30%)
                            带项目、资金、技术来我市创业，注册资本不低于500 万元，且实缴资本不低于50%。
                        </div>
                    </div>
                </div>

                <div class="zccl">
                    <img class="top" src="./../assets/imgs/76/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 国内外顶尖人才</div>
                            给予300万元资金资助和“一人一策”在实验室建设、科研经费、团队建设等方面提供稳定支持。
                        </div>
                        <div class="des">
                            <div class="title">二. 国家级科技领军人才</div>
                            给予300万元资金资助。
                        </div>
                        <div class="des">
                            <div class="title">三. 地方级科技领军人才</div>
                            给予150万元资金资助。
                        </div>
                        <div class="des">
                            <div class="title">四. 住房保障</div>
                            按规定享受人才购房或人才公寓政策支持。
                        </div>
                        <div class="des">
                            <div class="title">五. 子女入学</div>
                            按规定享受子女入学政策支持。
                        </div>
                        <div class="des">
                            <div class="title">六. 便捷就医</div>
                            按规定享受医疗便利政策支持。
                        </div>
                        <div class="des">
                            <div class="title">七. 景区观光</div>
                            按规定享受都江堰景区、青城山前景区、青城山后景区政策支持
                        </div>
                        <div class="des">
                            <div class="title">八. 其他</div>
                            按规定享受落户、商品折扣等服务保障
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/55/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申请</div>
                                </div>
                                <div class="line-content">
                                    创新创业人才在引进后稳定工作满1年即可向用人单位分别提交《都江堰市扶持高层次创新人才申报书》《都江堰市扶持高层次创业人才申报书》，用人单位经集体研究后，向所属产业功能区或镇(街道)提出申请。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">初审</div>
                                </div>
                                <div class="line-content">
                                    所属产业功能区或镇(街道)对创新创业人才申报材料的真实性进行初审，并报行业主管部门。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">复审</div>
                                </div>
                                <div class="line-content">行业主管部门对人才类别进行认定、对申报材料进行复审，经党委( 党组)会议研究后，报都江堰市委组织部。</div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">审查</div>
                                </div>
                                <div class="line-content">
                                    都江堰市委组织部于每年第四季度收集汇总 后征求公安、法院、检察院、税务、市场监管、环保等部门意见，对创新创业人才进行审查。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line" style="height: 120%;"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content">
                                    都江堰市委组织部对通过审查的创新创业人才进行5个工作日的公示。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">

                                    <div class="line-num">6</div>
                                    <div class="line-title">确定</div>
                                </div>
                                <div class="line-content">公示无异议的创新创业人才，报都江堰市委组织部部务会研究审定后，确定扶持对象，按程序申请资金资助。</div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61751563">028-61751563</a>
                            </div>
                        </div>
                        <div class="unit">
              <span class="label">责任单位：</span>
              都江堰市委组织部
            </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/76/code.png" />
                    <img class="text" src="../assets/imgs/76/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 3.94rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4rem;
            }
        }
    }
}
</style>
